import MiniLoading from './MiniLoading'

export default MiniLoading
